var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8716 5.30822C27.8716 2.47751 30.1664 0.18277 32.9971 0.18277H52.8745C55.7053 0.18277 58 2.47751 58 5.30822C58 8.13893 55.7053 10.4337 52.8745 10.4337H32.9971C30.1664 10.4337 27.8716 8.13893 27.8716 5.30822Z",
    fill: "#66E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 52.0282C0 49.1975 2.29475 46.9027 5.12546 46.9027H25.002C27.8327 46.9027 30.1274 49.1975 30.1274 52.0282C30.1274 54.8589 27.8327 57.1536 25.002 57.1536H5.12545C2.29474 57.1536 0 54.8589 0 52.0282Z",
    fill: "#66E0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6167 0H17.1203C7.7857 0 0.214976 7.5605 0.202372 16.8951C0.189723 26.2635 7.79276 33.8585 17.1611 33.8358L40.7257 33.779C44.2556 33.7705 47.1252 36.6229 47.1378 40.1528C47.1504 43.6945 44.2828 46.5723 40.7411 46.5723H19.4197C14.0297 46.5723 12.0645 53.6713 16.6872 56.4431C17.5127 56.9381 18.4572 57.1995 19.4197 57.1995H40.4947C49.8254 57.1995 57.3859 49.6288 57.3733 40.2981C57.3606 30.9853 49.8076 23.4424 40.4947 23.4424H16.9104C13.372 23.4424 10.5034 20.5742 10.5028 17.0358C10.5023 13.4966 13.3713 10.6272 16.9104 10.6272H32.6167C38.3527 10.6272 40.0191 2.79539 34.7799 0.460251C34.0991 0.156813 33.3621 0 32.6167 0Z",
    fill: "#00CCFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftNav);
export default __webpack_public_path__ + "static/media/left_nav.424f384747661a5454d29ffe1c0f442c.svg";
export { ForwardRef as ReactComponent };